import {DropdownMenu} from 'quickstart/components/controls/DropdownMenu'
import {MetaLink} from 'quickstart/components/tizra/MetaLink'
import {useSearch} from 'quickstart/hooks/useSearch'
import {useSearchConfig} from 'quickstart/hooks/useSearchConfig'
import {forwardRef} from 'react'

export type NavLinkExpandoProps = {
  metaTypes?: string[]
  adminTag?: string
  sortProp?: string
  sortDirection?: 'ascending' | 'descending'
}

export const NavLinkExpando = forwardRef<any, NavLinkExpandoProps>(
  (
    {
      metaTypes = ['AdminTagged'],
      adminTag = '',
      sortProp = 'Title',
      sortDirection = 'ascending',
    },
    ref,
  ) => {
    const searchConfig = useSearchConfig({
      mode: 'browse',
      metaTypes: {metadata: metaTypes},
      pre: {
        all: [adminTag],
      },
      fields: {
        depth: {defaultValue: 'metadata'},
        page: {defaultValue: 100},
        sort: {defaultValue: `sortProp-${sortDirection}`},
      },
      sorting: {sortProp},
    })
    const {results} = useSearch(searchConfig)
    if (!results) {
      return <DropdownMenu.Item ref={ref}>(none)</DropdownMenu.Item>
    }
    return (
      <>
        {results.map((r, i) => (
          <DropdownMenu.Item as={MetaLink} metaObj={r} key={i} />
        ))}
      </>
    )
  },
)
